import { NavBar } from '../../../Modules/Navigation/components/NavBar/NavBar';
import Card from '../../../ui/Card/Card';
import styles from './InstagramAudiosPage.module.css';
import InstagramAudios from '../../../Modules/Instagram/Audios/Explore/InstagramAudios';

const InstagramAudiosPage = () => {
    return (
        <>
            <NavBar />
            <Card className={styles.content}>
                <InstagramAudios />
            </Card>
        </>
    );
};

export default InstagramAudiosPage;
